import { cn } from "@/lib/utils";
import { PillIcon } from "lucide-react";
import { trans } from "@/service/i18n/i18n";
import { getBadgeColor, getTextColor } from "../../atc-helpers";
import { EmptyPlaceholder } from "@/components/ui/empty-placeholder";

export const AtcSelectionPanel = ({
  selectedAtc,
}: {
  selectedAtc: AtcItem | null;
}) => {
  if (!selectedAtc) {
    return (
      <EmptyPlaceholder
        icon={PillIcon}
        title={trans("meds.atc.select_code")}
        description="aby zobaczyć powiązane leki"
      />
    );
  }

  const depth =
    selectedAtc.code.length === 1
      ? 0
      : selectedAtc.code.length === 3
      ? 1
      : selectedAtc.code.length === 4
      ? 2
      : selectedAtc.code.length === 5
      ? 3
      : 4;

  return (
    <div className="bg-white pb-4">
      <div className="flex items-start justify-between gap-4">
        <div className="flex flex-col gap-1">
          {depth === 0 && (
            <div
              className={cn(
                "flex h-8 w-fit items-center justify-center rounded-md px-2 text-sm font-bold text-white",
                getBadgeColor(depth, 3),
              )}
            >
              Grupa {selectedAtc.code[0]}
            </div>
          )}
          {depth > 0 && (
            <>
              <h3
                className={cn(
                  "text-lg leading-8 font-semibold",
                  getTextColor(depth, 3),
                )}
              >
                {selectedAtc.code}
              </h3>
            </>
          )}
          <div>
            <p className="line-clamp-3 text-sm text-gray-600">
              {selectedAtc.titleText}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
